import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  Router,
  NavigationStart,
  Event as NavigationEvent,
} from '@angular/router';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { APIService } from '../../services/api.service';
import { MatDialog } from '@angular/material/dialog';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadFormComponent } from '../lead-form/lead-form.component';

@Component({
  selector: 'app-new-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.scss'],
  standalone: false,
})
export class NewFooterComponent implements OnInit {
  public isCollapsed = true;
  public currentUrlState: string = '/home';

  isViewMore: boolean[] = [];

  questionAnswer: any = [
    {
      question: 'What is Inforida, and how can it help our school?',
      answer:
        'Inforida is a comprehensive school management ERP solution designed to streamline administrative tasks, improve communication, and enhance academic operations for educational institutions.',
    },
    {
      question: '⁠How does Inforida improve fee collection?',
      answer:
        'Inforida improves fee collection by offering automated payment tracking, digital receipts, and multiple payment options (cash, card, online). The system also sends reminders for due payments, reducing delays and manual errors.',
    },
    {
      question: "Is Inforida customizable for my school's needs?",
      answer:
        'Yes, Inforida is highly customizable. You can tailor the platform according to your school’s requirements, including fee structures, roles, and permissions.',
    },
    {
      question: 'Can parents use Inforida?',
      answer:
        'Inforida automates the fee collection process by providing digital payment options, sending fee reminders, and generating digital receipts, making the process seamless and error-free.',
    },
    {
      question: 'Is there a mobile app for Inforida?',
      answer:
        'Yes, Inforida offers a mobile app for parents, students, and teachers, enabling access to important information and features anytime, anywhere.',
    },
    {
      question: 'What kind of support does Inforida offer?',
      answer:
        'Inforida provides 24/7 customer support, along with online resources such as tutorials, FAQs, and video guides to assist users with the platform.',
    },
    {
      question: 'Can Inforida handle multiple campuses?',
      answer:
        'Yes, Inforida supports multiple campuses, allowing centralized management of all school branches through a single dashboard.',
    },
    {
      question: 'How secure is my school’s data on Inforida?',
      answer:
        'Inforida uses advanced encryption and security protocols to ensure that all data is securely stored and protected from unauthorized access.',
    },
    {
      question: 'How do I get started with Inforida?',
      answer:
        'Simply contact our team for a free demo or trial, and we’ll guide you through the setup process, helping you implement Inforida in your school quickly and efficiently.',
    },
  ];
  baseUrl = 'https://cal.com/inforida-demo/30min';
  updatedLink: string = '';

  formData = {
    name: '',
    mobile: '',
    email: '',
    city: '',
    days: '',
    organizationName: '',
    totalStudents: null,
  };

  constructor(
    public router: Router,
    public gaService: GoogleAnalyticsService,
    public deviceDetectorService: DeviceDetectorService,
    private api: APIService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.currentUrlState = '/home';

    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        console.log('event', event);
        console.log('foot event.url', event.url);
        this.currentUrlState = event.url || this.currentUrlState;
      }
    });
    this.questionAnswer.forEach(() => {
      this.isViewMore.push(false);
    });
    this.isViewMore[0] = true;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile();
    // return (
    //   window.matchMedia(`(min-width: 200px)`).matches &&
    //   window.matchMedia(`(max-width: 800px)`).matches
    // );
  }

  goToPage() {
    const url =
      'https://cal.com/inforida-demo/30min?month=2025-01&date=2025-01-18';
    if (isPlatformBrowser(this.platformId)) {
      window.open(this.updatedLink, '_blank');
    }
  }

  updateLink() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const date = today.getDate().toString().padStart(2, '0');
    this.updatedLink = `${this.baseUrl}?month=${year}-${month}&date=${year}-${month}-${date}`;
  }

  resetForm() {
    this.formData = {
      name: '',
      mobile: '',
      email: '',
      city: '',
      days: '',
      organizationName: '',
      totalStudents: null,
    };
  }
  isNumber(val) {
    console.log('isNumber val', val);
    console.log('isNumber val', val, /^\d+$/.test(val + ''));
    if (val) return /^\d+$/.test(val + '');
    return false;
  }
  viewMore(index: any) {
    this.isViewMore[index] = !this.isViewMore[index];
  }

  openDialog() {
    this.dialog.open(LeadFormComponent, {
      width: this.isMobile() ? '90vw' : '800px',
      maxWidth: this.isMobile() ? '90vw' : '800px',
      height: this.isMobile() ? '90vh' : '600px',
      maxHeight: this.isMobile() ? '90vh' : '600px',
      restoreFocus: false,
      hasBackdrop: true,
      closeOnNavigation: false,
      disableClose: true,
    });
  }

  openBlogLink(blogNo) {
    switch (blogNo) {
      case 1:
        window.open(
          'https://blog.inforida.com/navigating-the-cbse-results-2024-insights-and-how-inforida-can-enhance-school-management/',
          '_blank'
        );
        break;
      case 2:
        window.open(
          'https://blog.inforida.com/the-secret-to-school-success-unlocking-inforidas-powerful-features/',
          '_blank'
        );
        break;
      case 3:
        window.open(
          'https://blog.inforida.com/5-ways-inforida-can-make-teachers-lives-easier-and-more-fulfilling/',
          '_blank'
        );
        break;
      case 4:
        window.open(
          'https://blog.inforida.com/managing-school-finances-with-inforida-a-comprehensive-guide-for-school-administrators/',
          '_blank'
        );
        break;
      case 5:
        window.open('https://blog.inforida.com/', '_blank');
        break;
    }
  }

  submitDetails() {
    if (!this.isNumber(this.formData.mobile)) {
      this._snackBar.open('Invalid mobile no!', 'OK', {
        duration: 6000,
      });
      return;
    }
    this.api.submitDemo(this.formData).subscribe(
      (res) => {
        this._snackBar.open('Your details are submitted!', '', {
          duration: 6000,
        });
        this.resetForm();
      },
      (err) => {
        this._snackBar.open('Your details are not submitted!', 'Resend', {
          duration: 6000,
        });
        this.resetForm();
      }
    );
  }

  goToCareers() {
    const url = 'https://www.linkedin.com/company/inforidatech/jobs/';
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }
}
